import React, { useEffect, useState } from "react";
import axios from "axios";
import useAuth from "../../../hooks/useAuth";
import { BASE_URL } from "../../../utils/Element";
import Modal from "../../../components/Modal/Modal";
import { NotificationManager } from "react-notifications";
import AddPropertyHistoryData from "../components/AddPropertyHistoryData";
import AddBovHistoryData from "../components/AddBovHistoryData";

const initialFormData = {
    suggested_sale_price: "",
    bov_date: "",
    suggested_cap_rate:"",
};

const EditBovHistoryModal = ({ showBovModal, onClose, selectedBovPropertyHistory, onPropertyHistoryAdded }) => {
  const [config] = useAuth();
  const [error, setError] = useState();
  const [formData, setFormData] = useState(initialFormData);

  useEffect(() => {
    if (selectedBovPropertyHistory) {
      setFormData({
        suggested_sale_price: selectedBovPropertyHistory?.suggested_sale_price || "",
        bov_date: selectedBovPropertyHistory?.bov_date || "",
        suggested_cap_rate: selectedBovPropertyHistory?.suggested_cap_rate || "",
      });
    }
  }, [selectedBovPropertyHistory]);

  const handleCancel = () => {
    onClose();
    setError();
    setFormData(initialFormData);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const dataToSend = {
      suggested_sale_price: formData?.suggested_sale_price,
      bov_date: formData?.bov_date,
      suggested_cap_rate: formData?.suggested_cap_rate,
    };
    axios
      .post(`${BASE_URL}/bovproperty-history-edit/${selectedBovPropertyHistory?.id}`, dataToSend, config)
      .then(() => {
        handleCancel();
        onPropertyHistoryAdded();
      })
      .catch((err) => {
        setError(err?.response?.data?.errors);
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      });
  };

  const clearError = (field) => {
    setError((prev) => ({ ...prev, [field]: "" }));
  };

  return (
    <Modal title={"Edit BOV History"} desc={"Edit the BOV history of this property"} show={showBovModal} onClose={handleCancel}>
      <AddBovHistoryData
        formData={formData}
        error={error}
        onSetFormData={(value) => {
          setFormData(value);
        }}
        clearError={clearError}
        handleSubmit={handleSubmit}
        handleCancel={handleCancel}
      />
    </Modal>
  );
};

export default EditBovHistoryModal;
